module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0109.jpg?v=6cc4fa20";